import React from 'react'
import { injectIntl } from 'react-intl'
import { Paper, Typography } from '@material-ui/core'
import messages from './translate'

function NoData(props) {
  const {
    message,
    intl: { formatMessage },
  } = props

  return (
    <Paper className="no-data">
      <Typography variant="h4">
        {typeof message === 'string' ? message : formatMessage(message)}
      </Typography>
    </Paper>
  )
}

NoData.defaultProps = {
  message: messages.noDataMessage,
}

export default injectIntl(NoData)
